export const comingSoonFormFields = {
  email: 'email',
  zipCode: 'zipCode',
  password: 'password',
};
